"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutSrcOptions = void 0;
let CheckoutSrcOptions = exports.CheckoutSrcOptions = /*#__PURE__*/function (CheckoutSrcOptions) {
  CheckoutSrcOptions["noImage"] = "noImage";
  CheckoutSrcOptions["surprise"] = "surprise";
  return CheckoutSrcOptions;
}({});
